/**
 * AOS (Animate On Scroll) Initialization for Shopify Dawn Theme
 * Compatible with Shopify's theme editor and section loading
 */

// AOS Configuration - will be set from theme settings
let AOS_CONFIG = {
  // Default settings
  duration: 800,
  easing: 'ease-in-out',
  once: true,
  mirror: false,
  anchorPlacement: 'top-bottom',
  offset: 120,
  delay: 0,
  disable: function () {
    return window.innerWidth < 768;
  },
};

// Get theme settings and update AOS config
function updateAOSConfig() {
  // Try to get settings from various possible locations
  let settings = {};

  // Method 1: Shopify theme settings
  if (window.Shopify && window.Shopify.theme && window.Shopify.theme.settings) {
    settings = window.Shopify.theme.settings;
  }
  // Method 2: Check if settings are in window object
  else if (window.theme && window.theme.settings) {
    settings = window.theme.settings;
  }
  // Method 3: Check for settings in meta tag
  else {
    const settingsMeta = document.querySelector('meta[name="theme-settings"]');
    if (settingsMeta) {
      try {
        settings = JSON.parse(settingsMeta.getAttribute('content'));
      } catch (e) {
        console.log('Could not parse theme settings from meta tag');
      }
    }
  }

  // Update config with settings or use defaults
  AOS_CONFIG.duration = settings.aos_duration || 800;
  AOS_CONFIG.offset = settings.aos_offset || 120;

  // Disable on mobile if setting is enabled
  if (settings.aos_disable_mobile) {
    AOS_CONFIG.disable = function () {
      return window.innerWidth < 768;
    };
  } else {
    AOS_CONFIG.disable = false;
  }

  // Debug logging (disabled for production)
  // console.log('AOS Config:', AOS_CONFIG);
  // console.log('Settings found:', settings);
}

// Initialize AOS
function initAOS() {
  if (typeof AOS !== 'undefined') {
    // Update config from theme settings
    updateAOSConfig();

    AOS.init(AOS_CONFIG);

    // Refresh AOS after dynamic content loads
    if (typeof AOS !== 'undefined') {
      AOS.refresh();
    }
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', initAOS);

// Re-initialize AOS when sections are loaded in theme editor
if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    // Small delay to ensure DOM is updated
    setTimeout(() => {
      if (typeof AOS !== 'undefined') {
        AOS.refresh();
      }
    }, 100);
  });

  document.addEventListener('shopify:section:reorder', function () {
    setTimeout(() => {
      if (typeof AOS !== 'undefined') {
        AOS.refresh();
      }
    }, 100);
  });

  document.addEventListener('shopify:section:unload', function () {
    setTimeout(() => {
      if (typeof AOS !== 'undefined') {
        AOS.refresh();
      }
    }, 100);
  });
}

// Re-initialize AOS when page content changes (for AJAX navigation)
document.addEventListener('shopify:page:loaded', function () {
  setTimeout(() => {
    if (typeof AOS !== 'undefined') {
      AOS.refresh();
    }
  }, 100);
});

// Handle window resize
let resizeTimeout;
window.addEventListener('resize', function () {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    if (typeof AOS !== 'undefined') {
      AOS.refresh();
    }
  }, 250);
});

// Utility function to refresh AOS manually
window.refreshAOS = function () {
  if (typeof AOS !== 'undefined') {
    AOS.refresh();
  }
};
